import React, { useEffect, useState, useRef } from "react"
import {
  Button,
  Col,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap"
import axios from "axios"
import { useFormik } from "formik"
import * as Yup from "yup"
import { useHistory } from "react-router-dom"
import { error } from "toastr"
import { MdOutlineCheckCircle } from "react-icons/md"
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3"
import ViewFiles from "./ViewFiles"

const fetchPdfAsFile = async (url, filename = "file.pdf") => {
  const response = await fetch(url)
  const blob = await response.blob()
  const file = new File([blob], filename, { type: blob.type })
  return file
}

const UploadProjectFiles = ({
  projectData,
  projectDocs,
  setLayout,
  setEditing,
}) => {
  const history = useHistory()

  const documents = [
    {
      arName: "وثيقة التأمين",
      enName: "Insurance Policy Documents",
      id: "IDI",
      required: true,
      multi: false,
      accept: ".pdf",
    },
    {
      arName: "المخططات المعمارية",
      enName: "Architectural Drawings",
      id: "AD",
      required: true,
      multi: true,
      accept: ".pdf",
    },
    {
      arName: "المخططات الإنشائية",
      enName: "Constrauction Drawings",
      id: "CD",
      required: true,
      multi: true,
      accept: ".pdf",
    },
    {
      arName: "تقرير التربة",
      enName: "Geotechnical Report",
      id: "SOIL",
      required: true,
      multi: true,
      accept: ".pdf",
    },
    {
      arName: "قوائم الكميات (BOQ)",
      enName: "Bill of Quantities (BOQ)",
      id: "BOQ",
      required: true,
      multi: true,
      accept: ".pdf",
    },
    {
      arName: "المخططات الإنشائية والمعمارية بصيغة AutoCAD",
      enName: "Constructions & Architectural Drawing (AutoCAD)",
      id: "CAD",
      required: true,
      multi: true,
      accept: ".dwg,.dxf",
    },
    {
      arName: "النموذج الإنشائي",
      enName: "Structural Model",
      id: "STR",
      required: false,
      multi: true,
      accept: ".edb,.fbd,.sdb,.rvt,.tek,.rtd,.r3d,.pln,.rar,.zip",
    },
    {
      arName: "الجداول الحسابية",
      enName: "Calculation Note",
      id: "CN",
      required: false,
      multi: true,
      accept: ".pdf",
    },
  ]

  const [selectedFiles, setSelectedFiles] = useState({})
  const [viewedFiles, setViewedFiles] = useState([])
  const [fileNames, setFileNames] = useState({})
  const [uploadingStatus, setUploadingStatus] = useState({}) // Track upload status per document

  console.log("fileNames", fileNames)

  console.log("selectedFiles", selectedFiles)

  useEffect(() => {
    const loadFiles = async () => {
      await Promise.all(
        documents.map(async doc => {
          if (!projectDocs[doc.id]) return

          const filenames = []
          const docFiles = await Promise.all(
            projectDocs[doc.id].map(item => {
              const filename = item.split(`${doc.id}/`)[1] || ""
              filenames.push(filename)
              return fetchPdfAsFile(item, filename)
            })
          )
          if (docFiles.length > 0) {
            setSelectedFiles(prev => ({ ...prev, [doc.id]: docFiles }))
            setFileNames(fileNames => ({
              ...fileNames,
              [doc.id]: filenames,
            }))
          }
        })
      )
    }

    loadFiles()
  }, [projectDocs])

  // Create refs dynamically for each document
  const fileInputRefs = useRef(
    documents.reduce((refs, doc) => {
      refs[doc.id] = React.createRef()
      return refs
    }, {})
  )

  //   ***************************** View Files Modal ****************************************
  const [viewDoc, setViewDoc] = useState()
  const [viewFilesModal, setViewFilesModal] = useState(false)

  const viewFilesToggle = () => {
    setViewFilesModal(!viewFilesModal)
  }

  const handleButtonViewClick = doc => {
    // console.log("docID", doc.id, selectedFiles[doc.id])
    setViewDoc(doc)
    setViewedFiles(selectedFiles[doc.id])
    setViewFilesModal(true)
  }

  //   ***************************** Select button click ****************************************
  const handleButtonSelectClick = docID => {
    fileInputRefs.current[docID].click()
  }

  //   ***************************** Send files to aws ****************************************
  const sendFiles = async (allFiles, docID) => {
    // console.log("allFiles", allFiles);

    setUploadingStatus(prev => ({ ...prev, [docID]: true })) // Set uploading to true

    const config = {
      bucketName: "cpv-new",
      dirName: `uploads/amanat/${projectData.PolicyNo}/${docID}`,
      region: "ams3",
      accessKeyId: "DO00MAT3NNZ2H2XTB4A6",
      secretAccessKey: "jJh6bHA7TqZJCM06vzKGTcEL/Bdo5QPfPFiQnlgC/R8",
      s3Url: "https://ams3.digitaloceanspaces.com",
    }

    // Initialize S3 Client
    const s3 = new S3Client({
      region: config.region,
      endpoint: config.s3Url,
      credentials: {
        accessKeyId: config.accessKeyId,
        secretAccessKey: config.secretAccessKey,
      },
    })

    const uploadedUrls = []

    for (const file of allFiles) {
      try {
        const nameOfFile = `${Date.now()}-${file.name.replaceAll(" ", "")}`
        const fileName = `${config.dirName}/${nameOfFile}`

        const arrayBuffer = await file.arrayBuffer()
        const fileBuffer = new Uint8Array(arrayBuffer)

        const params = {
          Bucket: config.bucketName,
          Key: fileName,
          Body: fileBuffer,
          ContentType: file.type,
          ACL: "public-read",
        }
        // Generate Signed URL
        const command = new PutObjectCommand(params)
        await s3.send(command)

        uploadedUrls.push(nameOfFile)
      } catch (error) {
        console.error("Upload failed:", error)
      }
    }

    // console.log("uploadedUrls", uploadedUrls)

    setUploadingStatus(prev => ({ ...prev, [docID]: false })) // Set uploading to false when done

    return uploadedUrls
  }

  //   ***************************** Send filename to RD App ****************************************
  const sendFileNameDocHandler = formData => {
    axios
      .post(
        process.env.REACT_APP_API_URL + "api/amanat/AddinFiles.php",
        formData
      )
      .then(res => {
        console.log("res", res)
      })
      .catch(err => console.log("err", err))
  }

  //   ***************************** handle file change ****************************************
  const handleFileChange = async (doc, docID, files) => {
    let fileName = []

    if (files && files.length > 0) {
      fileName = await sendFiles(files, docID)
    }
    console.log("fileName", fileName)
    if (
      (fileName && fileName.length > 0) ||
      (fileName.length === 0 && !doc.required)
    ) {
      setSelectedFiles(prev => ({
        ...prev,
        [docID]: files && files.length > 0 ? Array.from(files) : [], // Store all selected files for this input
      }))

      setFileNames(fileNames => ({ ...fileNames, [docID]: fileName }))

      const formData = {
        PerToken: localStorage.getItem("token"),
        PerUserID: localStorage.getItem("id"),
        PerRoleID: localStorage.getItem("userRoleID"),
        ProjectID: projectData.projectID,
        ...fileNames,
        [docID]: fileName,
      }

      // console.log("formData --------------", formData);
      sendFileNameDocHandler(formData)
    }
  }

  //   ***************************** Check submit validation ****************************************
  const checkValidSubmit = () => {
    const invalidDocs = documents.filter(
      doc => doc.required && !selectedFiles[doc.id]
    )

    console.log("invalidDocs", invalidDocs)

    if (invalidDocs.length > 0) {
      return false
    } else {
      return true
    }
  }

  //   ***************************** Handle submit ****************************************
  const handleSubmit = e => {
    e.preventDefault()

    // console.log("fileNames", fileNames)

    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      ProjectID: projectData.ProjectID,
      ...fileNames,
    }
    sendFileNameDocHandler(formData)
    setEditing(editing => !editing)
    setLayout("data-table")
  }

  const backHandler = () => {
    setEditing(editing => !editing)
    setLayout("data-table")
  }

  return (
    <div>
      <Row
        style={{ width: "80%" }}
        className="m-auto mb-3 d-flex justify-content-start align-items-center"
      >
        <Col>
          <Button onClick={backHandler}>Back</Button>
        </Col>
      </Row>
      <div className="d-flex justify-content-center">
        <form
          onSubmit={handleSubmit}
          className="p-3 mb-3"
          style={{
            width: "70%",
            boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.30)",
            // backgroundColor: "red",
          }}
        >
          <h5 className="mb-4">
            Kindly upload all required files below:
            {/* <span className="text-danger">*</span> */}
          </h5>

          {documents.map((item, i) => (
            <Row key={i} className="mb-2">
              <Col
                xs={9}
                className="d-flex justify-content-start align-items-center"
              >
                <label htmlFor="pdfFile">
                  {item.enName}
                  {/* <span className="text-danger">{item.required && " *"}</span> */}
                </label>
              </Col>
              <Col xs={1} className="d-flex justify-content-end">
                <Input
                  type="file"
                  id={`file-${item.id}`}
                  innerRef={el => (fileInputRefs.current[item.id] = el)}
                  accept={item.accept}
                  multiple={item.multi}
                  onChange={e =>
                    handleFileChange(item, item.id, e.target.files)
                  }
                  style={{ display: "none" }}
                />

                {selectedFiles[item.id] && selectedFiles[item.id].length > 0 ? (
                  <Button
                    disabled={uploadingStatus[item.id]}
                    onClick={() => handleButtonViewClick(item)}
                  >
                    View
                  </Button>
                ) : (
                  <Button onClick={() => handleButtonSelectClick(item.id)}>
                    Select
                  </Button>
                )}
              </Col>
              <Col
                xs={2}
                className="d-flex justify-content-center align-items-center"
              >
                {selectedFiles[item.id] &&
                  selectedFiles[item.id].length > 0 &&
                  !uploadingStatus[item.id] && (
                    <MdOutlineCheckCircle
                      style={{ fontSize: "28px", color: "green" }}
                    />
                  )}

                {uploadingStatus[item.id] && <Spinner size="sm" />}
              </Col>
            </Row>
          ))}

          <Row>
            <Col className="d-flex justify-content-end align-items-center mt-5">
              <Button
                type="submit"
                // disabled={!checkValidSubmit()}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </form>
      </div>

      {viewFilesModal && (
        <ViewFiles
          viewFilesToggle={viewFilesToggle}
          viewedFiles={viewedFiles}
          doc={viewDoc}
          handleFileChange={handleFileChange}
        />
      )}
    </div>
  )
}

export default UploadProjectFiles
